// @flow
import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';

import CF7FormObjectSelector from 'containers/contactForm7/CF7FormObjectSelectorContainer';
import type { ThemeType } from 'types/Faq';
import type { RouterProps } from 'types/Router';

export type StateProps = {
  faqThemes?: Array<ThemeType>
};

type Props = StateProps & RouterProps & {};

type State = {
  formSlug: string,
  initialValues: { [key: string]: any }
};

class ContactForm extends PureComponent<Props, State> {
  props: Props;

  state: State = {
    formSlug: '',
    initialValues: {}
  };

  componentDidMount() {
    const {
      location: { search }
    } = this.props;

    const params = new URLSearchParams(search);
    let formSlug = '';
    const initialValues = {};
    params.forEach((value, key) => {
      if (key === 'q') {
        formSlug = value;
      } else {
        initialValues[key] = value;
      }
    });

    this.setState({ formSlug, initialValues });
  }

  setFormSlug = (formSlug: string) => {
    this.setState({ formSlug });
  };

  render() {
    const { faqThemes } = this.props;
    const { formSlug, initialValues } = this.state;

    return (
      <div className="form-contact block-contact__form" style={{ display: 'block' }}>
        <h3 className="mb-1">Votre demande</h3>

        <p className="mb-3">Remplissez les champs ci-dessous pour contacter votre ligue.</p>

        <CF7FormObjectSelector
          customSelect={'SelectInput'}
          otherObjects={faqThemes}
          slug={formSlug}
          setFormSlug={this.setFormSlug}
          initialValues={initialValues}
        />
      </div>
    );
  }
}

export default withRouter(ContactForm);
